// reducers/timetableReducer.js
export const timetableReducer = (state = { timetable: [] }, action) => {
  switch (action.type) {
    case "TIMETABLE_REQUEST":
      return { ...state, loading: true };
    case "GET_TIMETABLE_SUCCESS":
      return { loading: false, timetable: action.payload };
    case "CREATE_TIMETABLE_SUCCESS":
      return { loading: false, success: true };
    case "DELETE_TIMETABLE_SUCCESS":
      return {
        ...state,
        loading: false,
        timetable: (state.timetable || []).filter(
          (t) => t.id !== action.payload,
        ),
      };
    case "TIMETABLE_FAIL":
      return { loading: false, error: action.payload };
    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false };
    default:
      return state;
  }
};
